<section class="p-2 p-md-4">
  <div class="card mb-4">
    <div class="card-header bg-white">
      <h3>Novo Fornecedor</h3>
    </div>
    <div class="card-body row">
      <div class="col-12 col-lg-6 p-2">
        <label for="nome">Nome</label>
        <input type="text" autocomplete="false" class="form-control input-validate" name="nome" id="nome" [formControl]="form.controls.nome">
        <app-msg-erro [control]="form.controls.nome"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-6 p-2">
        <label for="cnpj">CNPJ</label>
        <input type="text" autocomplete="false" class="form-control input-validate" name="cnpj" id="cnpj" [textMask]="masks.cnpj" [formControl]="form.controls.cnpj">
        <app-msg-erro [control]="form.controls.cnpj"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-6 p-2">
        <label for="url">URL</label>
        <input type="text" autocomplete="false" class="form-control input-validate" name="url" id="url" [formControl]="form.controls.url">
        <app-msg-erro [control]="form.controls.url"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-6 p-2">
        <label for="urldocumentacao">URL documentação</label>
        <input type="text" autocomplete="false" class="form-control input-validate" name="urldocumentacao" id="urldocumentacao" [formControl]="form.controls.urldocumentacao">
        <app-msg-erro [control]="form.controls.urldocumentacao"></app-msg-erro>
      </div>
    </div>
    <div class="d-flex justify-content-end card-footer bg-white text-muted">
      <button [disabled]="form.invalid" class="btn btn-lg px-5 btn-success" (click)="submitForm()">
        <span>Salvar</span>
      </button>
    </div>
  </div>
</section>